import type { ReactElement } from "react";
import { IconProps, SvgIcon } from "./SvgIcon";

export function GeminiIcon({ size, className }: IconProps): ReactElement {
  return (
    <SvgIcon viewBox="0 0 32 32" fill="none" size={size} className={className}>
      <g transform="translate(3, 3)">
        <path
          d="M26 13.527C22.6268 13.742 19.4457 15.2305 17.0561 17.7121C14.6664 20.1937 13.233 23.4971 13.026 27H12.974C12.7673 23.4969 11.3341 20.1933 8.94433 17.7117C6.55457 15.23 3.37331 13.7416 0 13.527L0 13.473C3.37331 13.2584 6.55457 11.77 8.94433 9.28834C11.3341 6.80667 12.7673 3.50305 12.974 0L13.026 0C13.233 3.50293 14.6664 6.80634 17.0561 9.28794C19.4457 11.7695 22.6268 13.258 26 13.473V13.527Z"
          fill="url(#paint0_radial_1627_398)"
        />
      </g>
      <defs>
        <radialGradient
          id="paint0_radial_1627_398"
          cx="0"
          cy="0"
          r="1"
          gradientTransform="matrix(26.2155 9.20582 -71.0132 218.079 5.5805 13.9738)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0.067" stop-color="#9168C0" />
          <stop offset="0.343" stop-color="#5684D1" />
          <stop offset="0.672" stop-color="#1BA1E3" />
        </radialGradient>
      </defs>
    </SvgIcon>
  );
}
